import { useEffect, useState } from "react";
import { AntSwitch } from "../mui-components/AntSwitch";
import Utils from "../util/Utils";
import { CargoTypes } from "./AgCargoTypes";
import { ControlledDetailSwitch } from "./AgControlledDetailSwitch";
import { MultiCargoDetails } from "./AgMultiCargoDetails";
import cargoDetail from "../assets/images/worldwide-shipping.svg";
import { TextField } from "@mui/material";
import { lclWeightForPort } from "../StaticData";
import { useMobile } from "../hooks/usemobile";

export function CargoDetails({form,viewonly}){
    const { control, watch,getValues,setValue,register,formState: { errors } } = form;
    const isMobile = useMobile();
    const [selectedDestIndex, setSelectedDestIndex] = useState(0);
    const Mode = watch("mode")
    let multidest = getValues("multidest")?getValues("multidest"):watch("multidest")
    let containerDetails = getValues("containerDetails")?getValues("containerDetails"):watch("containerDetails")
    const mode = Mode.toLowerCase();
    const Scope = watch("scope")
    const stuffingType = watch("stuffingType")
    let volumeInDimensions = watch("volumeInDimensions");
    const destuffingType = watch("destuffingType");
    const isFBA = watch("isFba")
    const dimensionsUnit = watch("cargoDimensionUnit");
    const cartingorderdisable = watch("cartingorderdisable");
    const [total,setTotal] = useState({ totNumPackages : 0,
        totTotalWeight : 0,
        totTotalVolume : 0,
        totChargeableWeight : 0,
    })
    const obj = {
        "stuffingType":stuffingType,
        "destuffingType":destuffingType,
        "shipmentType":mode,
        "shipmentScope":Scope
    }
    const [showAdvancedCargoDetails,setAdvancedCargoDetails] = useState(false);
    const [changeToDimension,setChangeToDimension] = useState(false);
    let isDimension = false;
    if (((mode === "lcl" &&  Scope.includes("Door")) || mode === "air" || mode === "fcl" || changeToDimension) && volumeInDimensions ) {
        isDimension = true;
    }
    useEffect(()=>{
        if(mode==="lcl" && Scope==="Port-to-Port"){
            setAdvancedCargoDetails(true);
        }else{
            setAdvancedCargoDetails(false);
        }
    },[Mode,Scope])

    

    useEffect(()=>{
        let totals = Utils.calcCargoDetailsGrand(multidest,isDimension,dimensionsUnit,mode);
         setChangeToDimension(isDimension)
        if(JSON.stringify(totals)!=JSON.stringify(total)){
            setTotal({...totals});
            setValue("grandTotalWeight",totals.totTotalWeight)
            setValue("grandTotalVolume",totals.totTotalVolume)
            setValue("grandChargeable",totals.totChargeableWeight)
         }  
    },[JSON.stringify(multidest),dimensionsUnit,isDimension,mode])
    useEffect(()=>{
        if(isFBA==true){
            if(multidest!=undefined){
                for (let i = 0; i < multidest.length; i++) {
                    if(multidest[i]['cargoDetails']!=undefined){
                        for (let j = 0; j < multidest[i]['cargoDetails'].length; j++) {
                            let pk = multidest[i]['cargoDetails'][j]['packageType']
                            if(pk!=undefined && pk!="" && ["Pallet","Loose Cartons"].indexOf(pk) == -1){
                                setValue(`multidest.${i}.cargoDetails.${j}.packageType`,"")
                            }
                        }
                    }
                }
            }
        }
        
    },[isFBA])
    let nonstackable = watch("nonStackable");
    const outGuage = watch("showCargoDetailsOutGuage");
    const showStackForFcl = ()=>{
        if(Mode=="FCL"){
            let origin = Scope.split("-")[0];
           
            let destination = Scope.split("-")[2];
            
                if((origin?.toLowerCase()==="door" && stuffingType.toLowerCase() === "dock" ) || (destination?.toLowerCase()==="door" && destuffingType.toLowerCase() === "dock" ) || (Scope!=="Port-to-Port" && stuffingType.toLowerCase() === "dock" && destuffingType.toLowerCase() === "dock") || outGuage){
                   return true
                }
                return false
        }else{
            return false
        }
        
    }
    const generateId = (id,i)=> {
        if(id==undefined){
            let a = i + Date.now() + '-' + Math.floor(Math.random() * 1000)
            multidest[i].id = a
            return a
        }else{
            return id
        }
    }

    const safeDestIndex = selectedDestIndex < (multidest?.length || 0) ? selectedDestIndex : 0;

    useEffect(() => {
        if (isMobile && multidest && multidest.length > 1 && errors?.multidest) {
            const errorIndex = multidest.findIndex((_, i) => Boolean(errors?.multidest?.[i]));
            if (errorIndex !== -1 && errorIndex !== selectedDestIndex) {
                setSelectedDestIndex(errorIndex);
            }
        }
    }, [errors, isMobile, multidest]);

    return  <div className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px]">
    <div className="flex flex-row justify-between items-center">
    <div className="flex flex-row gap-[10px]">
         <img src={cargoDetail}/>
         <p className="text-black font-bold">{Utils.labelForOutGauge1(obj,containerDetails)?"Cargo Details for Out-Gauge Containers":"Cargo Details"}</p>
      </div>
     {/* {showAdvancedCargoDetails && <div className="flex flex-row gap-1 items-center">
        <p className="text-black font-roboto">Advanced cargo details</p>
        <AntSwitch disabled={viewonly} checked={changeToDimension} onChange={(e)=>{
                setChangeToDimension(e.target.checked);
        }} />
      </div>} */}
      </div>
      {showStackForFcl() && <div className="flex flex-row gap-5"><ControlledDetailSwitch disable={cartingorderdisable!=undefined?cartingorderdisable:viewonly} control={control} isChecked={nonstackable} formKey={"nonStackable"} title={"Non-Stackable"}/>
          </div>
       }
     { mode.toLowerCase() !== "fcl" && <CargoTypes form={form} viewonly={viewonly} />}
     {isMobile && multidest && multidest.length > 1 && (
        <div className="flex flex-row gap-2 overflow-x-auto w-full pb-1 [&::-webkit-scrollbar]:hidden" style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}>
            {multidest.map((m, i) => {
                const isSelected = safeDestIndex === i;
                const hasError = Boolean(errors?.multidest?.[i]);
                return (
                    <button
                        key={i}
                        type="button"
                        onClick={() => setSelectedDestIndex(i)}
                        className={`relative px-4 py-2 rounded-[6px] text-sm font-semibold whitespace-nowrap border transition-colors flex items-center gap-1.5 ${
                            hasError
                                ? isSelected
                                    ? "bg-[#DC2626] text-white border-[#DC2626]"
                                    : "bg-[#FEF2F2] text-[#DC2626] border-[#FCA5A5]"
                                : isSelected
                                    ? "bg-[#4CA7DC] text-white border-[#4CA7DC]"
                                    : "bg-white text-[#333333] border-[#EEEEEE] shadow-0"
                        }`}
                    >
                        Destination {String(i + 1).padStart(2, '0')}
                        {hasError && (
                            <span className={`w-2 h-2 rounded-full ${isSelected ? "bg-white" : "bg-[#DC2626]"}`} />
                        )}
                    </button>
                );
            })}
        </div>
     )}
    {isMobile && multidest && multidest.length > 1 ? (
        multidest.map((m, i) => (
            <div key={generateId(m.id, i)} className={safeDestIndex === i ? "w-full" : "hidden"}>
                <MultiCargoDetails
                    form={form}
                    viewonly={cartingorderdisable != undefined ? cartingorderdisable : viewonly}
                    ind={i}
                    changeToDimension={changeToDimension}
                />
            </div>
        ))
    ) : (
        multidest && multidest.map((m,i)=>{
            return <MultiCargoDetails key={generateId(m.id,i)} form={form} viewonly={cartingorderdisable!=undefined?cartingorderdisable:viewonly} ind={i} changeToDimension={changeToDimension}/>
        })
    )}
     {
        multidest && multidest.length > 1 && (
           
                <><hr style={{margin:"0px"}}/><div className={`flex ${isMobile?"flex-col items-start gap-2.5" : "flex-row items-center"}  justify-between  w-full`}>
                          <div className="flex flex-row gap-2.5"><p className="text-blue-dark font-bold font-barlow">Grand Total Quantity :</p><p className="text-yellow font-bold font-barlow">{isNaN(total.totNumPackages)?0:total.totNumPackages}</p></div>
               <div className="flex flex-col">
                         <div className="flex flex-row gap-2.5">
                            <p className="text-blue-dark font-bold font-barlow pt-[2.5px]">{mode.toLowerCase()==="lcl" ? "Grand" : ""} Total Weight:</p>
                            <TextField
                              {...register("grandTotalWeight", { validate:(value)=>{
                                let maxValue = lclWeightForPort.grandtotalweight["kgs"]
                                 if(value > maxValue && mode.toLowerCase()==="lcl"){
                                    return `value can't be greater than ${maxValue} Kgs.`
                                 }
                              } })}
                              variant="standard"
                              value={isNaN(total.totTotalWeight)?0:total.totTotalWeight+ " " +"Kgs"}
                              fullWidth={false}
                              InputProps={{
                                disableUnderline: true,
                                readOnly: false,
                                 style:{
                                    color:"#F4B14A",
                                    fontWeight:"bold",
                                    fontFamily:"Barlow"
                                 }
                              }}
                            />
                            {/* <p className="text-yellow font-bold font-barlow">{isNaN(total.totTotalWeight)?0:total.totTotalWeight} Kgs</p> */}
                            </div>
                            {errors.grandTotalWeight && <p className="text-[#d32f2f] text-sm">{errors.grandTotalWeight.message}</p>}
                         </div>
                          { !(mode==="air") &&  
                              <div className="flex flex-col">
                              <div className="flex flex-row gap-2.5">
                                 <p className="text-blue-dark font-bold font-barlow pt-[2.5px]">{mode.toLowerCase()==="lcl" ? "Grand" : ""} Total Volume:</p>
                                 <TextField
                                   {...register("grandTotalVolume", { validate:(value)=>{
                                    console.log("the value in volume is ",value)
                                     let maxValue = lclWeightForPort.grandtotalvolume["cbm"]
                                      if(value > maxValue && mode.toLowerCase()==="lcl"){
                                         return `value can't be greater than ${maxValue} CBM.`
                                      }
                                   } })}
                                   variant="standard"
                                   value={isNaN(total.totTotalVolume)?0:total.totTotalVolume+ " " +"CBM"}
                                   fullWidth={false}
                                   InputProps={{
                                     disableUnderline: true,
                                     readOnly: false,
                                      style:{
                                         color:"#F4B14A",
                                         fontWeight:"bold",
                                         fontFamily:"Barlow"
                                      }
                                   }}
                                 />
                                 {/* <p className="text-yellow font-bold font-barlow">{isNaN(total.totTotalWeight)?0:total.totTotalWeight} Kgs</p> */}
                                 </div>
                                 {errors.grandTotalVolume && <p className="text-[#d32f2f] text-sm">{errors.grandTotalVolume.message}</p>}
                              </div>
                          }
                    { mode==="air" &&  
                    <div className="flex flex-row gap-2.5"><p className="text-blue-dark font-bold font-barlow">Grand Chargeable Weight:</p><p className="text-yellow font-bold font-barlow">{isNaN(total.totChargeableWeight)?0:total.totChargeableWeight} Kgs</p></div>}
                </div></>
        )
     }
     
    </div>
}